import { JSX } from 'react';

export default function getSelectDestination(destination: {
  value: string;
  label: string;
  icon: string;
}): {
  value: string;
  label: JSX.Element;
} {
  return {
    value: destination.value,
    label: (
      <div className="flex items-center gap-2">
        <img
          className="h-4 w-4 rounded-full mr-2 object-cover"
          src={destination.icon}
          alt={destination.label}
        />
        {destination.label}
      </div>
    ),
  };
}
